<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Add User</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtUsername">Username</label>
            <input type="text" class="form-control" id="txtUsername" v-model="user.username">
          </div>
          <div class="form-group">
            <label for="txtFirstName">First Name</label>
            <input type="text" class="form-control" id="txtFirstName" v-model="user.first">
          </div>
          <div class="form-group">
            <label for="txtLastName">Last Name</label>
            <input type="text" class="form-control" id="txtLastName" v-model="user.last">
          </div>
          <div class="form-group">
            <label for="txtPassword">Password</label>
            <input type="password" class="form-control" id="txtPassword" v-model="user.password">
          </div>
          <div class="form-group">
            <label for="ddlUserGroup">Group</label>
            <select class="form-control" id="ddlUserGroup" v-model="user.group_id">
              <option v-for="group in groups" :key="group.group_id" v-bind:value="group.group_id">
                {{ group.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="ddlUserDevice">Device</label>
            <select class="form-control" id="ddlUserDevice" v-model="user.device_id">
              <option value="null">(None)</option>
              <option v-for="device in filtered_devices" :key="device.device_id" v-bind:value="device.device_id">
                {{ device.name }}
              </option>
            </select>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" >Submit</button>
          <router-link :to="{ name: 'AdminUsersIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DEVICE_TYPE } from '../../../assets/js/resource-types'

export default {
  name: 'users-add',
  data: function () {
    return {
      user: {
        user_id: 0,
        group_id: 1,
        device_id: null,
        username: '',
        password: '',
        first: '',
        last: '',
        assigned_site_ids: []
      }
    }
  },
  computed: {
    ...mapGetters({
      groups: 'allGroups',
      devices: 'allDevices',
      sites: 'allSites',
      logged_in_user: 'loggedInUser'
    }),
    filtered_groups: function () {
      return this.groups.filter(group => this.showGroup(group.group_id))
    },
    filtered_devices: function () {
      return this.devices.filter(device => device.device_type_id == DEVICE_TYPE.SIP)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getGroups')
    this.$store.dispatch('getSites')
    this.$store.dispatch('getDevices')
  },
  methods: {
    showGroup (groupId) {
      if (this.logged_in_user.group_id === 2) {
        if ([1, 2].includes(groupId)) {
          return true
        } else {
          return false
        }
      } else if (this.logged_in_user.group_id === 4) {
        if ([1, 2, 4].includes(groupId)) {
          return true
        } else {
          return false
        }
      } else if (this.logged_in_user.group_id === 3) {
        return true
      }
    },
    submit () {
      this.$store.dispatch('addEditUser', this.user)
    }
  }
}
</script>

<style scoped>

</style>
